export const formatDeliveryMethods = deliveryMethods => {
  return deliveryMethods.map(dm => ({
    ...dm,
    name: dm.internal_name || dm.name,
    carbon_offset_fee: false,
  }))
}
